import { EXTERNAL_URLS } from '../constants/urls';

/**
 * Whether to use the OS share sheet for sharing. True only on a touch/mobile
 * context that exposes the Web Share API — there the native sheet is the
 * expected way to share (matching the mobile app). Desktop, and browsers
 * without Web Share, keep the in-app referral dialog.
 */
export function canNativeShare(): boolean {
  if (typeof navigator === 'undefined' || typeof navigator.share !== 'function') return false;
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(pointer: coarse)').matches;
}

/**
 * Open the OS share sheet with the VoteMate referral (message + site link),
 * mirroring the mobile app's Share.share. Resolves true when the native sheet
 * handled it — including the user dismissing it — and false when native share
 * is unavailable or blocked, so the caller can fall back to the dialog.
 */
export async function shareVoteMate(message: string): Promise<boolean> {
  if (!canNativeShare()) return false;
  try {
    await navigator.share({
      title: 'VoteMate',
      text: message,
      url: EXTERNAL_URLS.VOTEMATE_WEBSITE,
    });
    return true;
  } catch (err) {
    // The user dismissing the sheet rejects with AbortError — that's handled,
    // not a failure, so don't also open the dialog. Anything else (payload
    // rejected, blocked by permissions policy in an embed) falls back.
    return err instanceof Error && err.name === 'AbortError';
  }
}
